import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { Mail } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export const Route = createFileRoute("/_auth/messages/")({
  component: SupplyChain,
});

function SupplyChain() {
  return (
    <>
      <PageHeader title="Messages" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <EmptyState
          title="Messages"
          description="This feature will allow you to connect directly with Low Carbon Technologies staff and platform admins to troubleshoot application issues, ask questions and discover new opportunities. Keep communication flowing and make the most of every step toward certification while we measure the carbon footprint of your cattle."
          Icon={Mail}
        />
      </main>
    </>
  );
}
